import {sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {history} from 'core/history';
import {ROUTE} from 'core/routes';

import {createAppealFx, createRequested, fetchThemesFx, Gate, themes$} from './index';

sample({clock: createRequested, target: createAppealFx});
sample({clock: Gate.open, target: fetchThemesFx});

themes$.on(fetchThemesFx.doneData, (_, themes) => themes).reset(Gate.close);

createAppealFx.doneData.watch((id) => {
    toast.success(i18next.t('pages.complaints.create.success'));
    history.push(ROUTE.COMPLAINTS_DETAIL.replace(':id', String(id)));
});

createAppealFx.failData.watch((error) => showRestError(error as RestError));
fetchThemesFx.failData.watch((error) => showRestError(error as RestError));
